import 'magnific-popup';
import 'select2';
import lazySizes from 'lazysizes';
// import 'lazysizes/plugins/blur-up/ls.blur-up';
// import 'lazysizes/plugins/parent-fit/ls.parent-fit';

lazySizes.cfg.minSize = 200;
lazySizes.cfg.init = false;

// document.addEventListener('lazybeforesizes', function(e) {
//     //calculate the size as a number
//     console.log(e);
//     // e.detail.width = yourCalculation(e.target) || e.detail.width;
// });


// WEBPACK FOOTER //
// ./scripts/autoload/_vendors.js